<template>
    <div class="fw-jddsh">
        <div class="sousuo">
            <div class="sou-item">
                <van-search
                        v-model="phone"
                        placeholder="请输入手机号搜索"
                        shape="round"
                >
                </van-search>
            </div>
        </div>
        <Cxdate @chaxun="chaxun"/>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <div class="oo-items" v-for="(item,index) in list">
                <div class="mbinfo" style="border-bottom: #C0BEC0 solid 0px;">
                    <div>
                        <img v-if="item.headPortrait" :src="item.headPortrait" class="my-tou"/>
                        <div v-else>
                            <img v-if="item.sex==0" src="../../../assets/nan.png" class="my-tou"/>
                            <img v-if="item.sex==1" src="../../../assets/nan.png" class="my-tou"/>
                            <img v-if="item.sex==2" src="../../../assets/nv.png" class="my-tou"/>
                        </div>
                    </div>
                    <div class="my-mbinfo">
                        <span>{{item.memberName}}</span>
                        <span style="font-size: 10px;">{{item.phone}}</span>
                    </div>
                </div>
                <div class="ooinfo">
                    <div class="ooinfo-item">
                        <span class="oi-name">订单编号:</span>
                        <span class="oi-val">{{item.orderNo}}</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">支付时间:</span>
                        <div class="mmdd">
                            <span class="oi-val">{{item.payTime}}</span>
                            <span class="oi-val1" v-if="!item.payStatus||item.payStatus==0">未支付</span>
                            <span class="oi-val1" v-if="item.payStatus==1">已支付</span>
                        </div>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">支付方式:</span>
                        <span class="oi-val" v-if="item.payType==0">微信支付</span>
                        <span class="oi-val" v-if="item.payType==2">金豆支付</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">配送方式:</span>
                        <span class="oi-val" v-if="item.shippingType==0">到店</span>
                        <span class="oi-val" v-if="item.shippingType==1">快递</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">订单状态:</span>
                        <span class="oi-val" v-if="item.orderStatus==1">待发货</span>
                        <span class="oi-val" v-if="item.orderStatus==2">已发货</span>
                        <span class="oi-val" v-if="item.orderStatus==3">已完成</span>
                    </div>
                </div>
                <div class="oi-btn">
                    <van-button type="default" class="oi-bi2" @click="toFh(item,index)">去发货</van-button>
                </div>
            </div>
        </van-list>

        <van-popup v-model="fhShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 100%;overflow:hidden;padding-bottom: 50px">
             <span class="md-bt">
                    <span>发货</span>
                    <i class="el-icon-close" @click="guanbi"></i>
             </span>
            <div class="mbitem">
                <div class="mbinfo" style="border-bottom: #C0BEC0 solid 0px;">
                    <div>
                        <img v-if="order.headPortrait" :src="order.headPortrait" class="my-tou"/>
                        <div v-else>
                            <img v-if="order.sex==0" src="../../../assets/nan.png" class="my-tou"/>
                            <img v-if="order.sex==1" src="../../../assets/nan.png" class="my-tou"/>
                            <img v-if="order.sex==2" src="../../../assets/nv.png" class="my-tou"/>
                        </div>
                    </div>
                    <div class="my-mbinfo">
                        <span>{{order.memberName}}</span>
                        <span style="font-size: 10px;">{{order.phone}}</span>
                    </div>
                </div>
                <div class="dizhi">
                    <span>地址:</span>
                    <span style="margin-left: 5px">{{order.address}}</span>
                </div>
            </div>
            <div class="dditem">
                <div class="ddod">
                    <span class="ddod-bt">订单编号:</span>
                    <span>{{order.orderNo}}</span>
                </div>
                <div class="ddod1">
                    <span class="ddod-bt1">订单内容:</span>
                    <div class="goodsinfo" v-for="info in order.orderInfos">
                        <div class="goodsname">
                            <span style="width: 50%;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{info.name}}</span>
                            <span style="width: 25%;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;text-align: right">{{info.specs}}</span>
                            <span style="width: 25%;text-align: right">x{{info.skuNum}}</span>
                        </div>
                        <div class="mingxi" v-if="info.goodsItems&&info.goodsItems.length>0">
                            <div class="xitem" v-for="item in info.goodsItems">
                                <span style="width: 75%;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.itemName}}</span>
                                <span style="width: 25%;text-align: right">x{{item.total}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ddod1">
                    <span class="ddod-bt1">备注查阅:</span>
                    <span class="beizhu">{{order.mark}}</span>
                </div>
            </div>

            <el-form ref="form" label-width="100px" style="margin-top: 30px">
                <el-form-item label="快递公司:" size="mini">
                    <span @click="xze">{{kdName}}</span>
                </el-form-item>
                <el-form-item label="快递单号:" size="mini" >
                    <el-input v-model="courierNo" placeholder="快递单号" style="width: 260px"></el-input>
                </el-form-item>
            </el-form>
            <div class="mb-btn">
                <van-button type="default" class="quedingbtn" @click="deliver">确定</van-button>
            </div>
        </van-popup>

        <van-popup v-model="fhShow1" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-picker show-toolbar  title="快递公司" @cancel="fhShow1 = false" :columns="kds" @confirm="onConfirm"  />
        </van-popup>

    </div>
</template>

<script>
    import {getCookie,} from "../../../utils/auth";
    import Cxdate from "../../common/cxdate.vue";

    export default {
        components: {Cxdate},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',

                dateType: 0,
                staDate: '',
                endDate: '',
                phone: '',
                list: [],
                loading: false,
                finished: false,
                page: 1,

                fhShow: false,
                fhShow1: false,
                order:{},
                kds: [],
                kdCompany: '',
                courierNo: '',
                uoid:'',
                kdMap:{},
                odIndex:'',
                kdName:'选择快递',
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            // this.userType = this.fwUser.userType
            this.getKds();
        },
        methods: {
            async getKds() {
                let res = await this.$get('/fw/getDictDetails', {dictName: 'KD_TYPE'})
                let arr=[]
                res.list.forEach(item => {
                    arr.push(item.label)
                    this.kdMap[item.label] = item.value
                })
                this.kds = arr
            },
            xze(){
                this.fhShow1= true
            },
            onConfirm(val){
                this.kdCompany=this.kdMap[val]
                this.kdName=val
                this.fhShow1= false
            },
            chaxun(data) {
                this.dateType = data.dateType
                this.staDate = data.staDate
                this.endDate = data.endDate
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            onSearch() {
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },

            toFh(item,index) {
                this.uoid=item.id
                this.odIndex=index
                this.fhShow = true
                if (!this.order.id||item.id!=this.order.id){
                    this.getOrderInfo()
                }
            },

            async deliver() {
                if (!this.courierNo) {
                    this.$notify({message: "请输入快递单号", duration: 1000, background: 'red'});
                    return;
                }
                let data = {
                    id: this.uoid,
                    courierNo: this.courierNo,
                    kdCompany: this.kdCompany,
                    kdName: this.kdName,
                    token:this.token
                }
                let res = await this.$post("/fw/deliver", data)
                if (res.code == 200) {
                    this.list.splice(this.odIndex, 1)
                    this.guanbi()
                    this.$notify({message: res.message, duration: 1000, background: '#1989fa'});
                } else {
                    this.$notify({message: res.message, duration: 1000, background: 'red'});
                }
            },

            async getOrderInfo() {
                let data = {
                    id: this.uoid,
                }
                let res = await this.$get("/fw/getFhOrderInfo", data)
                this.order=res.order
                console.log(this.order)
            },

            async onLoad() {
                let currentPage = this.page || 1;
                let data = {
                    token: this.token,
                    dateType: this.dateType,
                    staDate: this.staDate,
                    endDate: this.endDate,
                    shippingType: 1,
                    orderStatus:1,
                    phone: this.phone,
                    currentPage
                }
                let res = await this.$get("/fw/getDfhOrderList", data)
                if (res.code == 200) {
                    const count =res.dataSet.list.length
                    const newList =res.dataSet.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
            },
        //去重
        quchong(arr, property) {
            const seen = new Set();
            return arr.filter(item => {
                const key = item[property];
                return !seen.has(key) && seen.add(key);
            });
        },
            guanbi() {
                this.fhShow = false
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-jddsh {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-bottom: 49px;
    }

    .mbinfo {
        display: flex;
        flex-direction: row;
        padding: 10px;
    }

    .my-tou {
        height: 40px;
        width: 40px;
    }

    .my-mbinfo {
        display: flex;
        flex-direction: column;
    }

    .jd-items {
        padding: 10px;
        margin-top: 5px;
        background-color: #FFFFFF;
    }

    .sousuo {
        background-color: #FFFFFF;
        padding-top: 10px;
    }

    .sou-item {
        padding: 0 28px;
    }

    .mbinfo {
        display: flex;
        flex-direction: row;
        padding: 10px 10px 0 10px;
        border-bottom: #C0BEC0 solid 1px;
    }

    .my-tou {
        height: 40px;
        width: 40px;
    }

    .my-mbinfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .my-mbinfo span {
        font-size: 13px;
        height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 16px
    }

    .oo-items {
        background-color: #FFFFFF;
        margin: 10px;
        padding: 0 8px;
    }

    .ooinfo {
        padding: 10px 16px;
    }

    .ooinfo-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 11px;
    }

    .mmdd {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 11px;
        width: 80%;
    }

    .oi-name {
        width: 55px;
        height: 35px;
        line-height: 35px;
    }

    .oi-val {
        height: 35px;
        line-height: 35px;
    }

    .oi-val1 {
        width: 60px;
        text-align: center;
        padding: 3px;
        background-color: #212121;
        color: #FFFFFF;
    }

    .oi-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-top: 10px;
        padding-bottom: 20px;
    }

    .oi-bi1 {
        background-color: #FD99B0;
        width: 100px;
        height: 28px;
        color: #FFFFFF;
        border-radius: 5px;
        font-size: 12px;
        margin: 0 20px;
    }

    .oi-bi2 {
        background-color: #9086DF;
        width: 100px;
        height: 28px;
        color: #FFFFFF;
        border-radius: 5px;
        font-size: 12px;
        margin: 0 20px;
    }

    .odbt {
        display: block;
        font-size: 13px;
        border-bottom: #DDDCDD solid 1px;
    }

    .goodsitem {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 12px;
        height: 35px;
        line-height: 35px;
    }

    .oi-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-top: 10px;
        padding-bottom: 20px;
    }

    .oi-bi1 {
        background-color: #FD99B0;
        width: 100px;
        height: 28px;
        color: #FFFFFF;
        border-radius: 5px;
        font-size: 12px;
        margin: 0 20px;
    }

    .oi-bi2 {
        background-color: #9086DF;
        width: 100px;
        height: 28px;
        color: #FFFFFF;
        border-radius: 5px;
        font-size: 12px;
        margin: 0 20px;
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .mb-btn {
        width: 100%;
        position: fixed;
        bottom: 0px;
    }

    .quedingbtn {
        width: 100%;
        text-align: center;
        height: 40px;
        background-color: #1989FA;
        color: #ffffff;
    }
    .mbitem{
        padding: 0 10px;
    }
    .dizhi{
        font-size: 13px;
        margin: 10px;
        padding-bottom: 6px;
        border-bottom: #e5e5e5 solid 1px;
    }
    .dditem{
        padding: 0 20px;
    }
    .ddod{
        display: flex;
        flex-direction: row;
        font-size: 13px;
        align-items: center;
        margin-bottom: 10px;
    }
    .ddod-bt{
        width: 65px;
        margin: 5px;
    }

    .ddod1{
        display: flex;
        flex-direction: row;
        font-size: 13px;
        margin-bottom: 5px;
    }
    .ddod-bt1{
        width: 65px;
        margin: 0 5px 5px 5px;
    }
    .goodsinfo{
        width: 80%;
        margin-bottom: 10px;
        background-color: #F8F8F8;
        border-radius: 3px;
        padding: 5px;
    }
    .goodsname{
        display: flex;
        flex-direction: row;
        font-size: 13px;
        padding-bottom: 2px;
        border-bottom: #ffffff solid 2px;
    }
    .goodsname span{
        padding: 2px 5px 2px 0;
    }
    .mingxi{
        margin: 2px 0;
    }
    .xitem{
        display: flex;
        flex-direction: row;
        padding: 4px 5px;
        font-size: 10px;
        color: #a2a2a2;
    }
    .beizhu{
        width: 80%;
        height: 60px;
        border: #e5e5e5 solid 1px;
        white-space: pre-wrap;
        padding: 5px;
        font-size: 11px;
    }

</style>